import { useAuth, useProfile } from "@brg/auth";

const useAuthStateReady = () => {
  const { token } = useAuth();
  const profile = useProfile();

  return !token || (token && profile);
};

export default useAuthStateReady;import { useAuth, useProfile } from "@brg/auth";

const useAuthStateReady = () => {
  const { token } = useAuth();
  const profile = useProfile();

  return !token || (token && profile);
};

export default useAuthStateReady;